// Money + delta formatting for the owner desk. The delta helpers return the numeral only — the
// caller tints the numeral (down = red, up = green) and NEVER the container (semantic colour ruling,
// 7 Sep: a falling mark is the Underwriter working correctly, not a broken building).

export function fmtMoney(n) {
  if (n == null) return "—";
  const abs = Math.abs(n);
  if (abs >= 1_000_000) return `$${(n / 1_000_000).toFixed(2)}M`;
  if (abs >= 1_000) return `$${Math.round(n / 1_000)}k`;
  return `$${n}`;
}

// Money-as-you-type for the intake "what it is worth" / your-number field (Step D ②A). Takes the raw
// input string, keeps digits only, and renders "$1,234,567" for display. The stored value is always a
// WHOLE-DOLLAR INTEGER (digits, no cents) — the caller parses the same digits back with parseInt.
export function fmtMoneyInput(raw) {
  const digits = String(raw ?? "").replace(/[^0-9]/g, "");
  if (!digits) return "";
  return `$${Number(digits).toLocaleString("en-US")}`;
}

// Simple English pluralise for a count + noun ("1 building" / "2 buildings").
export function plural(n, singular, pluralForm) {
  return `${n} ${n === 1 ? singular : pluralForm || singular + "s"}`;
}

export function fmtSigned(n) {
  const abs = Math.abs(n);
  const body = abs >= 1_000_000 ? `$${(abs / 1_000_000).toFixed(2)}M`
    : abs >= 1_000 ? `$${Math.round(abs / 1_000)}k` : `$${abs}`;
  return `${n < 0 ? "−" : "+"}${body}`;
}

// The five empty-cell classes (R1-OD-15) → owner-facing label + which semantic the label carries.
// amber = needs a human; red = disputed; neutral = inert/unavailable. Never a container tint.
export const EMPTY_LABELS = {
  awaiting_owner: { text: "needs you", tone: "amber" },
  optional_blank: { text: "—", tone: "neutral" },   // F26: a blank OPTIONAL number is neutral, not amber
  upstream_incomplete: { text: "—", tone: "neutral" },
  // F83: a building with nothing on file is a FINISHED state — neutral words, no line, no amber.
  no_document: { text: "No document on file — send me the rent roll or OM and I'll mark it",
                 tone: "neutral" },
  working: { text: "working…", tone: "neutral" },
  no_result: { text: "no result", tone: "neutral" },
  not_in_release: { text: "Release 2", tone: "neutral" },
  reading: { text: "reading your file", tone: "neutral" },
  waiting_on_you: { text: "waiting on you", tone: "amber" },
  needs_a_person: { text: "With our team", tone: "neutral" },
};
